import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ToastComponent, ToastData } from '../add-ons/toast/toast.component';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private readonly snackBar = inject(MatSnackBar);

  public open(data: ToastData, duration?: number) {
    this.snackBar.openFromComponent(ToastComponent, {
      data: data,
      duration: duration,
      verticalPosition: 'top',
      panelClass: [`toast-${data.type}`]
    });
  }

  public error(value: {
    message?: string;
    translationMsg?: string;
    translationParam?: Record<string, unknown>;
  }): void {
    this.open(
      {
        message: value?.message,
        type: 'error',
        closable: true,
        translationMessageKey: value?.translationMsg,
        translationMessageParams: value?.translationParam
      },
      5000
    );
  }

  public success(value: {
    message?: string;
    translationMsg?: string;
    translationParam?: Record<string, unknown>;
  }): void {
    this.open(
      {
        message: value?.message,
        type: 'success',
        closable: true,
        translationMessageKey: value?.translationMsg,
        translationMessageParams: value?.translationParam
      },
      5000
    );
  }
}
